import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../lib/GlobalVar';
import Swal from 'sweetalert2';
import { ConsultaTelegram, ConsultaRotinas, ConsultaInternas, SalvaCanalTelegram, SalvaBotTelegram, TestaTelegram, ConsultaSmtp, SalvaSmtp, TestaSmtp, VinculaTelegramGera, TelegramPareamento, ConsultaTemplatesNotif, SalvaTemplateNotif, RemoveTemplateNotif, ResolveTemplateNotif, ConsultaAcessosTelegram, SalvaAcessosTelegram } from '../../lib/api';
import Icon from '../Icon';
import TemplateEditor from '../TemplateEditor';

const ABAS = [
    { id: 'vinculo',   label: 'Vínculo & Tutorial' },
    { id: 'templates', label: 'Templates' },
    { id: 'bot',       label: 'Bot' },
    { id: 'canais',    label: 'Canais por setor' },
    { id: 'smtp',      label: 'SMTP / E-mail' },
    { id: 'rotinas',   label: 'Rotinas vinculadas' },
    { id: 'mensagens', label: 'Mensagens 24h' },
    { id: 'template',  label: 'Template padrão' },
    { id: 'acesso',    label: 'Acesso às opções' }
];

const SETORES = [{v:'TI',l:'TI'},{v:'Comercial',l:'Comercial'},{v:'Marketing',l:'Marketing'},{v:'Financeiro',l:'Financeiro'},{v:'Operacoes',l:'Operações'},{v:'Logistica',l:'Logística'},{v:'Relacionamento',l:'Relacionamento'},{v:'Diretoria',l:'Diretoria'}];

export default function TITelegram() {
    const { user } = useContext(GlobalContext);
    const [aba, setAba] = useState('canais');
    const [estado, setEstado] = useState({ bot: null, canais: [], rotinas: [], mensagens: [], template: '', vinculos: [] });
    const [modal, setModal] = useState(null);

    useEffect(() => { reload(); }, []);

    async function reload() {
        const resp = await ConsultaTelegram({});
        if (resp.Error) return;
        setEstado({
            bot: resp.bot || { username: '@babita_central_bot', online: true, webhook: 'ok', token_mask: '•••••••' },
            canais: resp.canais || [],
            rotinas: resp.rotinas || [],
            mensagens: resp.mensagens || [],
            template: resp.template || '',
            vinculos: resp.vinculos || []
        });
    }

    async function salvarCanal(form) {
        if (!form.nome || !form.chat_id) return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Nome e chat_id obrigatórios.' });
        if (!form.setor) return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Escolha o setor.' });
        const resp = await SalvaCanalTelegram({ canal: form, solicitante: user?.email });
        if (resp.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: resp.Error });
        Swal.fire({ icon: 'success', title: 'Canal salvo', timer: 1100, showConfirmButton: false });
        setModal(null);
        reload();
    }

    // "Tornar canal": abre o modal ja preenchido com os dados do vinculo (chat + setor do login).
    function tornarCanal(v) {
        setModal({ nome: v.nome || v.login, chat_id: v.chat_id, setor: v.setor || 'TI' });
    }

    const counts = {
        canais: estado.canais.length,
        rotinas: estado.rotinas.length,
        mensagens: estado.mensagens.length,
        template: estado.template ? 1 : 0,
        vinculo: (estado.vinculos || []).length
    };

    return (
        <div className="page">
            <div className="page-head">
                <div>
                    <div className="eyebrow"><span className="num ti">TI</span> Telegram &amp; Notificações</div>
                    <h1 className="page-title">Telegram &amp; Notificações</h1>
                    <p className="page-sub">
                        Bot oficial <span className="mono">{estado.bot?.username || '@babita_central_bot'}</span>. Canais por setor + rotinas vinculadas + stream de envios + template padrão.
                    </p>
                </div>
                <div style={{ display:'flex', gap:8 }}>
                    <button className="btn" onClick={() => setModal({ nome: '', chat_id: '', setor: 'TI' })}>
                        <Icon name="plus" size={12}/> Novo canal
                    </button>
                </div>
            </div>

            <div className="card" style={{ marginBottom: 18 }}>
                <div className="bot-row">
                    <div className="bot-icon"><Icon name="send" size={20}/></div>
                    <div style={{ flex: 1 }}>
                        <div className="eyebrow">Bot oficial</div>
                        <div className="bot-name">{estado.bot?.username || '@babita_central_bot'}</div>
                        <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>
                            token <span className="mono">{estado.bot?.token_mask || '•••••••'}</span> · webhook {estado.bot?.online ? 'ok' : 'verifique'}
                        </div>
                    </div>
                    <button className="btn ghost sm">Trocar token</button>
                </div>
            </div>

            <div className="tabs">
                {ABAS.map(a => (
                    <button key={a.id} className={`tab ${aba === a.id ? 'active' : ''}`} onClick={() => setAba(a.id)}>
                        {a.label.toUpperCase()} {counts[a.id] != null && <span className="tab-count">{String(counts[a.id]).padStart(2, '0')}</span>}
                    </button>
                ))}
            </div>

            {aba === 'vinculo' && <VinculoTutorial vinculos={estado.vinculos} onReload={reload} onTornarCanal={tornarCanal} canais={estado.canais}/>}

            {aba === 'canais' && (
                <div className="card flat" style={{ padding: 0 }}>
                    <div className="list-rows">
                        {estado.canais.map(c => (
                            <div className="row" key={c.chat_id}>
                                <div><b>{c.nome}</b> <span className="muted mono" style={{ fontSize: 11 }}>{c.chat_id}</span></div>
                                <span className="chip">{c.setor}</span>
                                <button className="btn ghost sm" onClick={() => setModal({ ...c })}>Editar</button>
                            </div>
                        ))}
                        {estado.canais.length === 0 && <div className="row muted">Nenhum canal cadastrado.</div>}
                    </div>
                </div>
            )}

            {aba === 'templates' && <TemplatesNotif/>}

            {aba === 'acesso' && <AcessoOpcoes/>}

            {aba === 'bot' && (
                <div className="card">
                    <div className="eyebrow" style={{ marginBottom:8 }}>Token + username do bot</div>
                    <BotForm bot={estado.bot} onSalvo={() => window.location.reload()}/>
                </div>
            )}

            {aba === 'smtp' && (
                <div className="card">
                    <div className="eyebrow" style={{ marginBottom:8 }}>Servidor SMTP (envio de e-mail)</div>
                    <SmtpForm/>
                </div>
            )}

            {aba === 'rotinas' && (
                <div className="card flat muted">Rotinas vinculadas (vem do Crontab).</div>
            )}

            {aba === 'mensagens' && (
                <div className="log-viewer" style={{ minHeight: 320 }}>
                    {estado.mensagens.length === 0 && <div style={{ opacity: .5 }}>Sem mensagens nas últimas 24h.</div>}
                    {estado.mensagens.map((m, i) => (
                        <div className="log-line" key={i}>
                            <span className="lvl-ok">[{m.hora}]</span> {m.canal}: {m.texto}
                        </div>
                    ))}
                </div>
            )}

            {aba === 'template' && (
                <div className="card">
                    <div className="field">
                        <label>Template padrão das notificações</label>
                        <TemplateEditor
                            value={estado.template}
                            onChange={t => setEstado({ ...estado, template: t })}
                            rows={10}
                            placeholder="{routine}: {status} em {duration}"
                            vars={[
                                { token: '{routine}', label: 'nome da rotina', opcoes: async () => { const r = await ConsultaRotinas({}); return (Array.isArray(r) ? r : (r.rotinas || [])).map(x => x.nome).filter(Boolean); } },
                                { token: '{status}', label: 'SUCESSO/ERRO', opcoes: ['SUCESSO', 'ERRO'] },
                                { token: '{duration}', label: 'duração' },
                                { token: '{summary}', label: 'resumo/erro' },
                                { token: '{sector}', label: 'setor', opcoes: ['TI','Comercial','Marketing','Financeiro','Operacoes','Logistica','Relacionamento','Diretoria'] },
                                { token: '{route}', label: 'rota/script' },
                                { token: '{server}', label: 'servidor', opcoes: ['NODECLOUD','IABabita'] },
                            ]}
                            kpiTelas={async () => {
                                const r = await ConsultaInternas({ solicitante: 'tecnologia@babita.com.br' });
                                return (Array.isArray(r) ? r : []).filter(t => t.slug && (t.colunas || []).length).map(t => ({
                                    slug: t.slug, titulo: t.titulo || t.slug,
                                    colunas: (t.colunas || []).map(c => ({ valor: String(c.nome != null ? c.nome : c.chave), label: c.label || c.nome || c.chave })),
                                }));
                            }}
                        />
                    </div>
                </div>
            )}

            {modal && <CanalModal form={modal} setForm={setModal} onClose={() => setModal(null)} onSave={() => salvarCanal(modal)}/>}
        </div>
    );
}

function CanalModal({ form, setForm, onClose, onSave }) {
    function up(k, v) { setForm({ ...form, [k]: v }); }
    // inclui o setor atual (ex.: vindo do login: TECNOLOGIA) mesmo que nao esteja na lista fixa
    const opcoes = (form.setor && !SETORES.some(s => s.v === form.setor)) ? [{ v: form.setor, l: form.setor }, ...SETORES] : SETORES;
    return (
        <div className="modal-mask" onClick={onClose}>
            <div className="modal" onClick={e => e.stopPropagation()}>
                <div className="modal-head">
                    <div className="eyebrow">Canal Telegram</div>
                    <button className="icon-btn" onClick={onClose}><Icon name="x" size={14}/></button>
                </div>
                <div className="modal-body">
                    <div className="field"><label>Nome</label><input className="input" value={form.nome} onChange={e => up('nome', e.target.value)}/></div>
                    <div className="field"><label>Chat ID</label><input className="input mono" value={form.chat_id} onChange={e => up('chat_id', e.target.value)}/></div>
                    <div className="field"><label>Setor</label><select className="select" value={form.setor} onChange={e => up('setor', e.target.value)}>
                        {opcoes.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
                    </select></div>
                </div>
                <div className="modal-foot">
                    <button className="btn ghost sm" onClick={onClose}>Cancelar</button>
                    <button className="btn sm" onClick={onSave}>Salvar</button>
                </div>
            </div>
        </div>
    );
}


function AcessoOpcoes() {
    const { user } = useContext(GlobalContext);
    const [dados, setDados] = useState(null);
    const [porOpcao, setPorOpcao] = useState({});
    const [porUsuario, setPorUsuario] = useState({});
    const [salvando, setSalvando] = useState(false);
    useEffect(() => {
        ConsultaAcessosTelegram({}).then(r => {
            if (!r || r.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: (r && r.Error) || 'Falha ao carregar acessos.' });
            setDados(r); setPorOpcao(r.acessos?.porOpcao || {}); setPorUsuario(r.acessos?.porUsuario || {});
        });
    }, []);
    if (!dados) return <div className="card flat muted">Carregando…</div>;
    const opcoes = dados.opcoes || [], setores = dados.setores || [], vinculos = dados.vinculos || [];
    const setorMarcado = (key, setor) => (porOpcao[key]?.setores || []).includes(setor);
    function toggleSetor(key, setor) {
        setPorOpcao(prev => {
            const cur = { setores: [...((prev[key] || {}).setores || [])], cargos: [...((prev[key] || {}).cargos || [])] };
            const set = new Set(cur.setores); set.has(setor) ? set.delete(setor) : set.add(setor);
            cur.setores = [...set];
            return { ...prev, [key]: cur };
        });
    }
    const estadoUsr = (chave, key) => {
        const ov = porUsuario[chave] || {};
        if ((ov.bloquear || []).includes(key)) return 'bloquear';
        if ((ov.permitir || []).includes(key)) return 'permitir';
        return '';
    };
    function ciclaUsr(chave, key) {
        setPorUsuario(prev => {
            const base = prev[chave] || {};
            const ov = { permitir: (base.permitir || []).filter(k => k !== key), bloquear: (base.bloquear || []).filter(k => k !== key) };
            const est = estadoUsr(chave, key);
            if (est === '') ov.permitir.push(key);
            else if (est === 'permitir') ov.bloquear.push(key);
            return { ...prev, [chave]: ov };
        });
    }
    async function salvar() {
        setSalvando(true);
        const r = await SalvaAcessosTelegram({ solicitante: user?.email, porOpcao, porUsuario });
        setSalvando(false);
        if (r && r.Error) return Swal.fire({ icon: 'error', title: 'Erro', text: r.Error });
        Swal.fire({ icon: 'success', title: 'Acessos salvos', timer: 1200, showConfirmButton: false });
    }
    return (
        <div className="card">
            <div className="eyebrow" style={{ marginBottom: 8 }}>Acesso às opções do bot — <b>Administrador</b> sempre vê tudo; opção sem setor marcado usa o padrão (as sensíveis 🔒 ficam só para TI).</div>
            <div style={{ overflowX: 'auto' }}>
                <table className="preview-table" style={{ fontSize: 12 }}>
                    <thead><tr><th style={{ textAlign: 'left' }}>Opção</th>{setores.map(s => <th key={s}>{s}</th>)}</tr></thead>
                    <tbody>
                        {opcoes.map(o => (
                            <tr key={o.key}>
                                <td style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{o.label}{o.soTIDefault ? ' 🔒' : ''}</td>
                                {setores.map(s => (
                                    <td key={s} style={{ textAlign: 'center' }}>
                                        <input type="checkbox" checked={setorMarcado(o.key, s)} onChange={() => toggleSetor(o.key, s)} />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="eyebrow" style={{ margin: '18px 0 8px' }}>Exceções por usuário (vinculados ao bot) — clique cicla: · → ✅ liberar → 🚫 bloquear</div>
            {vinculos.length === 0 ? <div className="muted" style={{ fontSize: 12 }}>Nenhum usuário vinculado ao bot.</div> : (
                <div style={{ overflowX: 'auto' }}>
                    <table className="preview-table" style={{ fontSize: 12 }}>
                        <thead><tr><th style={{ textAlign: 'left' }}>Usuário</th>{opcoes.map(o => <th key={o.key} title={o.label}>{o.label.replace(/^\S+\s/, '').slice(0, 6)}</th>)}</tr></thead>
                        <tbody>
                            {vinculos.map(v => (
                                <tr key={v.chave}>
                                    <td style={{ whiteSpace: 'nowrap', textAlign: 'left' }}><b>{v.nome}</b> <span className="muted" style={{ fontSize: 10 }}>{v.setor}</span></td>
                                    {opcoes.map(o => { const e = estadoUsr(v.chave, o.key); return (
                                        <td key={o.key} style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => ciclaUsr(v.chave, o.key)}>{e === 'permitir' ? '✅' : e === 'bloquear' ? '🚫' : '·'}</td>
                                    ); })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
                <button className="btn sm" onClick={salvar} disabled={salvando}>{salvando ? 'Salvando…' : 'Salvar acessos'}</button>
            </div>
        </div>
    );
}

function BotForm({ bot, onSalvo }) {
    const { user } = useContext(GlobalContext);
    const [token, setToken] = useState('');
    const [username, setUsername] = useState((bot && bot.username) || '@babita_central_bot');
    const [salvando, setSalvando] = useState(false);
    async function salvar() {
        setSalvando(true);
        const r = await SalvaBotTelegram({ solicitante: user?.email, token: token || undefined, username });
        setSalvando(false);
        if (r.Error) return Swal.fire({ icon:'error', title:'Erro', text:r.Error });
        Swal.fire({ icon:'success', title:'Bot salvo', timer:1200, showConfirmButton:false });
        setToken('');
        onSalvo && onSalvo();
    }
    async function testar() {
        const { value: chatId } = await Swal.fire({ title:'Testar bot', input:'text', inputLabel:'Chat ID', inputPlaceholder:'860112...' });
        if (!chatId) return;
        const r = await TestaTelegram({ chat_id: chatId, mensagem: 'Teste do bot Babita 🎉' });
        if (r.Error) return Swal.fire({ icon:'error', title:'Falhou', html:`<pre style="text-align:left;font-size:11.5px;white-space:pre-wrap">${r.Error}</pre>`, width:640 });
        Swal.fire({ icon:'success', title:'Mensagem enviada!', text:`message_id=${r.message_id}`, timer:2000 });
    }
    return (
        <div>
            <div className="cfg-row-2">
                <div className="field"><label>Username (@bot)</label><input className="input mono" value={username} onChange={e=>setUsername(e.target.value)} placeholder="@meu_bot"/></div>
                <div className="field"><label>Token (do BotFather)</label><input className="input mono" type="password" value={token} onChange={e=>setToken(e.target.value)} placeholder={bot?.token_mask || 'Cole o token aqui'}/></div>
            </div>
            <div className="muted" style={{ fontSize:11.5, marginTop:6 }}>
                Token cifrado AES antes de gravar. Status atual: {bot?.configurado ? <span className="chip on">configurado</span> : <span className="chip">vazio</span>}
            </div>
            <div style={{ display:'flex', gap:8, marginTop:14, justifyContent:'flex-end' }}>
                <button className="btn ghost sm" onClick={testar}>Testar envio</button>
                <button className="btn sm" onClick={salvar} disabled={salvando}>{salvando ? 'Salvando…' : 'Salvar bot'}</button>
            </div>
        </div>
    );
}

function SmtpForm() {
    const { user } = useContext(GlobalContext);
    const [cfg, setCfg] = useState({ host:'', porta:587, seguranca:'starttls', usuario:'', senha:'', remetente:'', dominio:'', configurado:false, senha_mask:'' });
    const [salvando, setSalvando] = useState(false);
    useEffect(() => { ConsultaSmtp({}).then(r => { if (!r.Error) setCfg(c => ({ ...c, ...r, senha:'' })); }); }, []);
    function up(k, v) { setCfg({ ...cfg, [k]: v }); }
    async function salvar() {
        if (!cfg.host || !cfg.usuario) return Swal.fire({ icon:'warning', title:'Atenção', text:'Host e usuário obrigatórios.' });
        if (!cfg.configurado && !cfg.senha) return Swal.fire({ icon:'warning', title:'Atenção', text:'Informe a senha na primeira configuração.' });
        setSalvando(true);
        const r = await SalvaSmtp({ solicitante: user?.email, host:cfg.host, porta:cfg.porta, seguranca:cfg.seguranca, usuario:cfg.usuario, senha:cfg.senha || undefined, remetente:cfg.remetente, dominio:cfg.dominio });
        setSalvando(false);
        if (r.Error) return Swal.fire({ icon:'error', title:'Erro', text:r.Error });
        Swal.fire({ icon:'success', title:'SMTP salvo', timer:1200, showConfirmButton:false });
        setCfg({ ...cfg, senha:'', configurado:true, senha_mask:'••••••' });
    }
    async function testar() {
        const { value: dest } = await Swal.fire({ title:'Testar envio', input:'email', inputLabel:'Destinatário', inputPlaceholder:user?.email || 'voce@babita.com.br', inputValue:user?.email || '' });
        if (!dest) return;
        const r = await TestaSmtp({ solicitante: user?.email, destino: dest });
        if (r.Error) return Swal.fire({ icon:'error', title:'Falhou', html:`<pre style="text-align:left;font-size:11.5px;white-space:pre-wrap">${r.Error}</pre>`, width:640 });
        Swal.fire({ icon:'success', title:'E-mail enviado!', text:`messageId=${r.messageId}`, timer:2200 });
    }
    return (
        <div>
            <div className="cfg-row-2">
                <div className="field"><label>Host SMTP</label><input className="input mono" value={cfg.host} onChange={e=>up('host',e.target.value)} placeholder="email.babita.com.br"/></div>
                <div className="field"><label>Porta</label><input className="input mono" type="number" value={cfg.porta} onChange={e=>up('porta',Number(e.target.value))}/></div>
            </div>
            <div className="cfg-row-2">
                <div className="field"><label>Segurança</label>
                    <select className="select" value={cfg.seguranca} onChange={e=>up('seguranca',e.target.value)}>
                        <option value="starttls">STARTTLS (porta 587 — recomendado)</option>
                        <option value="tls">SSL/TLS implícito (porta 465)</option>
                        <option value="none">Nenhuma (porta 25 — sem criptografia)</option>
                    </select>
                </div>
                <div className="field"><label>Domínio (opcional, HELO)</label><input className="input mono" value={cfg.dominio} onChange={e=>up('dominio',e.target.value)} placeholder="babita.com.br"/></div>
            </div>
            <div className="cfg-row-2">
                <div className="field"><label>Usuário</label><input className="input mono" value={cfg.usuario} onChange={e=>up('usuario',e.target.value)} placeholder="babita.rafael@babita.com.br"/></div>
                <div className="field"><label>Senha</label><input className="input" type="password" value={cfg.senha} onChange={e=>up('senha',e.target.value)} placeholder={cfg.configurado ? cfg.senha_mask : 'Senha do email'}/></div>
            </div>
            <div className="field"><label>Remetente "From" (opcional)</label><input className="input mono" value={cfg.remetente} onChange={e=>up('remetente',e.target.value)} placeholder="Babita Central <central@babita.com.br>"/></div>
            <div className="muted" style={{ fontSize:11.5, marginTop:6 }}>
                Status atual: {cfg.configurado ? <span className="chip on">configurado</span> : <span className="chip">vazio</span>} · senha cifrada AES antes de gravar.
            </div>
            <div style={{ display:'flex', gap:8, marginTop:14, justifyContent:'flex-end' }}>
                <button className="btn ghost sm" onClick={testar} disabled={!cfg.configurado && !cfg.senha}>Enviar teste</button>
                <button className="btn sm" onClick={salvar} disabled={salvando}>{salvando ? 'Salvando…' : 'Salvar SMTP'}</button>
            </div>
        </div>
    );
}


function VinculoTutorial({ vinculos = [], onReload, onTornarCanal, canais = [] }) {
    const { user } = useContext(GlobalContext);
    const [codigo, setCodigo] = useState('');
    const jaCanal = (chat_id) => (canais || []).some(c => String(c.chat_id) === String(chat_id));
    async function gerarCodigo() {
        const r = await VinculaTelegramGera({ solicitante: user?.email });
        if (r.Error) return Swal.fire({ icon:'error', title:'Erro', text:r.Error });
        setCodigo(r.codigo);
        Swal.fire({ icon:'success', title:'Código gerado', html:`Envie no @CentralBabita_bot:<br><b style="font-size:22px">/start ${r.codigo}</b><br><small>Válido por 10 min</small>`, timer:9000 });
    }
    async function ativarPareamento() {
        const r = await TelegramPareamento({ solicitante: user?.email });
        if (r.Error) return Swal.fire({ icon:'error', title:'Erro', text:r.Error });
        Swal.fire({ icon:'info', title:'Pareamento ativo (10 min)', text:'Abra o @CentralBabita_bot e envie /start (sem código). O próximo /start vincula a você.' });
    }
    return (
        <div className="card">
            <div className="eyebrow" style={{ marginBottom:10 }}>Como conectar seu Telegram ao painel</div>
            <ol style={{ fontSize:13, lineHeight:1.9, paddingLeft:18, margin:'0 0 16px' }}>
                <li>Abra o Telegram e procure por <b className="mono">@CentralBabita_bot</b>.</li>
                <li>Entre com <b>uma</b> das opções:
                    <ul style={{ marginTop:6 }}>
                        <li><b>Login direto:</b> envie <span className="mono">seu.login:suasenha</span> (apague a mensagem depois).</li>
                        <li><b>Código:</b> clique em "Gerar código" abaixo e envie <span className="mono">/start CÓDIGO</span>.</li>
                        <li><b>Pareamento:</b> clique em "Ativar pareamento" e envie só <span className="mono">/start</span>.</li>
                    </ul>
                </li>
                <li>Pronto! Use o menu do bot: 📊 Dashboard, 📋 Telas (PNG/Excel), 🔔 Alertas, ⏰ Rotinas e mais.</li>
            </ol>
            <div style={{ display:'flex', gap:8, marginBottom:18, flexWrap:'wrap' }}>
                <button className="btn sm" onClick={gerarCodigo}><Icon name="plus" size={11}/> Gerar código de vínculo</button>
                <button className="btn ghost sm" onClick={ativarPareamento}><Icon name="refresh" size={11}/> Ativar pareamento (próximo /start)</button>
                {codigo && <span className="chip on mono">/start {codigo}</span>}
            </div>
            <div className="eyebrow" style={{ marginBottom:8 }}>Chats vinculados ({vinculos.length})</div>
            <div className="muted" style={{ fontSize:11.5, marginBottom:8 }}>
                "Tornar canal" faz o chat receber as notificações por setor (tasklist, agenda) do setor do usuário.
            </div>
            <div className="list-rows">
                {vinculos.map(v => (
                    <div className="row" key={v.chat_id}>
                        <div style={{ flex:1 }}><b>{v.nome || v.login}</b> <span className="muted mono" style={{ fontSize:11 }}>chat {v.chat_id} · {v.login}</span></div>
                        <span className="chip">{v.setor || '—'}</span>
                        {jaCanal(v.chat_id)
                            ? <span className="chip on" style={{ fontSize:11 }}>já é canal</span>
                            : <button className="btn ghost sm" onClick={() => onTornarCanal && onTornarCanal(v)}><Icon name="send" size={11}/> Tornar canal</button>}
                        <span className="muted" style={{ fontSize:11 }}>{v.vinculado_em ? new Date(v.vinculado_em).toLocaleString('pt-BR') : ''}</span>
                    </div>
                ))}
                {vinculos.length === 0 && <div className="row muted">Nenhum chat vinculado ainda.</div>}
            </div>
        </div>
    );
}

function TemplatesNotif() {
    const { user } = useContext(GlobalContext);
    const [lista, setLista] = useState([]);
    const [edit, setEdit] = useState(null);
    const [preview, setPreview] = useState('');
    useEffect(() => { recarrega(); }, []);
    async function recarrega() { const r = await ConsultaTemplatesNotif({}); setLista(Array.isArray(r) ? r : []); }
    async function salvar() {
        if (!edit.nome) return Swal.fire({ icon: 'warning', title: 'Nome obrigatório' });
        const r = await SalvaTemplateNotif({ solicitante: user?.email, template: edit });
        if (r.Error) return Swal.fire({ icon: 'error', title: 'Erro', text: r.Error });
        setEdit(null); setPreview(''); recarrega();
        Swal.fire({ icon: 'success', title: 'Template salvo', timer: 1000, showConfirmButton: false });
    }
    async function remover(t) {
        const c = await Swal.fire({ icon: 'question', title: `Remover "${t.nome}"?`, showCancelButton: true });
        if (!c.isConfirmed) return;
        await RemoveTemplateNotif({ solicitante: user?.email, id: t.id }); recarrega();
    }
    async function previewTpl() {
        const r = await ResolveTemplateNotif({ texto: edit.texto });
        setPreview(r.texto || r.Error || '(vazio)');
    }
    const kpiTelas = async () => {
        const r = await ConsultaInternas({ solicitante: user?.email });
        return (Array.isArray(r) ? r : []).filter(t => t.slug && (t.colunas || []).length).map(t => ({
            slug: t.slug, titulo: t.titulo || t.slug,
            colunas: (t.colunas || []).map(c => ({ valor: String(c.nome != null ? c.nome : c.chave), label: c.label || c.nome || c.chave })),
        }));
    };
    const VARS = [
        { token: '{saudacao}', label: 'saudação', opcoes: ['Bom dia', 'Boa tarde', 'Boa noite'] },
        { token: '{data}', label: 'data' }, { token: '{hora}', label: 'hora' },
        { token: '{alertas}', label: 'alertas pend.' }, { token: '{rotinas}', label: 'rotinas ativas' },
    ];
    return (
        <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div className="eyebrow">Templates de notificação ({lista.length}) · usados no bot (botão Templates) e no Crontab</div>
                {!edit && <button className="btn sm" onClick={() => { setEdit({ nome: '', texto: '' }); setPreview(''); }}><Icon name="plus" size={11}/> Novo template</button>}
            </div>
            {!edit && (
                <div className="list-rows">
                    {lista.map(t => (
                        <div className="row" key={t.id}>
                            <div style={{ flex: 1 }}><b>{t.nome}</b> <span className="muted mono" style={{ fontSize: 11 }}>{(t.texto || '').slice(0, 70)}{(t.texto || '').length > 70 ? '…' : ''}</span></div>
                            <button className="btn ghost sm" onClick={() => { setEdit({ ...t }); setPreview(''); }}>Editar</button>
                            <button className="btn ghost sm" onClick={() => remover(t)}>Excluir</button>
                        </div>
                    ))}
                    {lista.length === 0 && <div className="row muted">Nenhum template. Crie um e use no bot ou no Crontab.</div>}
                </div>
            )}
            {edit && (
                <div>
                    <div className="field"><label>Nome do template</label><input className="input" value={edit.nome} onChange={e => setEdit({ ...edit, nome: e.target.value })} placeholder="Ex: Resumo de vendas do dia"/></div>
                    <div className="field"><label>Conteúdo</label>
                        <TemplateEditor value={edit.texto} onChange={t => setEdit({ ...edit, texto: t })} rows={6} vars={VARS} kpiTelas={kpiTelas} placeholder="Ex: Bom dia! Vendas até agora: {kpi:slug|coluna|soma}"/>
                    </div>
                    {preview && <div className="card" style={{ background: 'var(--bg-2)', marginBottom: 10 }}><div className="eyebrow" style={{ marginBottom: 6 }}>Pré-visualização</div><div style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{preview}</div></div>}
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                        <button className="btn ghost sm" onClick={() => { setEdit(null); setPreview(''); }}>Cancelar</button>
                        <button className="btn ghost sm" onClick={previewTpl}>Pré-visualizar</button>
                        <button className="btn sm" onClick={salvar}>Salvar template</button>
                    </div>
                </div>
            )}
        </div>
    );
}
